<template lang="">
    <div class="section-cv">
         <div class="heading2-section cv">
            References
        </div>
        <div class="section-context references">
            <div class="reference" v-for="reference in references" :key="reference.referenceId">
                <div class="refname">{{reference.name}}</div>
                <div class="position">{{reference.position}}</div>
                <div class="company">{{reference.company}}</div>
                <div class="email">{{reference.email}}</div>
                <div class="phone">{{reference.phone}}</div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    computed:{
        references(){
             var refs = this.$store.getters["cvbuilder/getCVInformation"]?.references || [];
            return refs;
        }
    }
}
</script>
<style scoped>

    .references{
        display: grid;
        grid-template-columns: repeat(3,1fr);
        column-gap:0.5rem;
        row-gap:0.5rem;
    }

    .refname{
       font-weight:bold;
       color:var(--tertiary); 
    }

    .position, .company{
        font-weight:bold;
    }

    .company{
        /* font-style: italic; */
        /* color:var(--darkgrey); */
    }

    .email, .phone{
        color:var(--darkgrey);
    }

    
</style>